import { BaseModel } from './base';

export class Supplier extends BaseModel {
  idSupplier!: number;

  override objectID(): string | null {
    return this.idSupplier?.toString() ?? null;
  }
}
